import { httpService } from '@/api/v1/http.service'
import useDownload, { type DownloadParams } from '@/hooks/useDownload'
import { formatApiDate } from '@/utils/format-date'
import { parseColumnsToFetchKeys } from '@/utils/parse-columns-to-fetch-keys'

import { type SchoolBreaksParams } from '../queries/useSchoolBreaks'

type Params = DownloadParams & SchoolBreaksParams

const useSchoolBreaksDownload = (schoolBreaksParams: Params) =>
  useDownload({
    fileName: 'school_breaks',
    requestParams: schoolBreaksParams,
    // @ts-expect-error Waits for backend fix - file type should be returned
    downloadMutation: (params: Params) =>
      httpService.panel.panelSchoolBreaksList(
        {
          year: params.year,
          ends_after: params.dateAfter
            ? formatApiDate(new Date(params.dateAfter))
            : undefined,
          starts_before: params.dateBefore
            ? formatApiDate(new Date(params.dateBefore))
            : undefined,
          status: params.status === 'past' ? ['past'] : ['active', 'future'],
          search: params.search,
          ordering: params.status === 'past' ? '-start_date' : 'start_date',
          format: params.format,
          fetchKeys: parseColumnsToFetchKeys(params.columnsKey, params.format)
        },
        { format: 'blob' }
      )
  })

export default useSchoolBreaksDownload
